import { Validator } from "../validator/Validator";

export default class InputValidation {
  static isValidInput(showErrors = true, input: any) {
    let isValidField = null;

    if (input.validatorType && !input.disabled) {
      isValidField = input.validatorType?.every((field: any) => {
        const localHasError = !Validator.run(input.value, field.validation, input.validatorParams);
        
        if (showErrors && localHasError) {
          input.hasError = localHasError;
          input.errorMsg = field.message;
          
         
        }
        return !localHasError;
      })
    }
    return isValidField;
  }
};

export { InputValidation }